"use strict";
import "src/decidim/decidim_awesome/awesome_application.js";
require.context("../images", true);
import "entrypoints/decidim_decidim_awesome.scss";
